var map = {
	"./buy/buy.vue": "lGX1",
	"./buySuccess/buySuccess.vue": "Vq4+",
	"./comfirm/confirm.vue": "idJx",
	"./douyin/douyin.vue": "bSYb",
	"./guidance/guidance.vue": "9wY0",
	"./identity/identity.vue": "8q77",
	"./login/login.vue": "6Qob",
	"./lottery/lottery.vue": "cCA+",
	"./points/points.vue": "4vH4",
	"./poster/poster.vue": "jEFn",
	"./posterComes/posterComes.vue": "eYC6",
	"./prove/prove.vue": "PlO1",
	"./publicity/publicity.vue": "odQK",
	"./share/share.vue": "aufS",
	"./veteran/veteran.vue": "ew7M",
	"./vipLogin/vipLogin.vue": "tZN2",
	"./weibo/weibo.vue": "mgZi",
	"./weixin/weixin.vue": "at1j",
	"./win/win.vue": "fmKa"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "v1t/";


//////////////////
// WEBPACK FOOTER
// ./src/view .vue
// module id = v1t/
// module chunks = 1